/* eslint-disable no-plusplus */
/* eslint-disable fp/no-mutating-methods */
/* eslint-disable fp/no-mutation */
import mime from 'mime';
import {isEmpty, isString} from './boolean';
import {getObjectProp} from './object';

export const getFilename = url => {
  let filename = url.substring(url.lastIndexOf('/') + 1);
  if (filename.includes('?')) {
    // eslint-disable-next-line fp/no-mutation
    filename = filename.split('?');
    // eslint-disable-next-line fp/no-mutation
    [filename] = filename;
  }
  return filename;
};

export const getFileNameFromURL = file => {
  if (file.url) {
    const cleanURL = file.url.split(/[?#]/)[0];
    return cleanURL.substring(cleanURL.lastIndexOf('/') + 1);
  }
  return '';
};

export const getFileName = file => {
  if (file.filename) {
    return file.filename.replace('./', '');
  }

  if (file.url) {
    return getFileNameFromURL(file);
  }
  return '';
};

export const getFileExtension = file => {
  if (file.filetype) {
    return mime.getExtension(file.filetype);
  }

  let filetype = mime.getType(getFileName(file));

  if (!filetype) {
    // eslint-disable-next-line fp/no-mutation
    filetype = mime.getType(getFileNameFromURL(file));
  }

  if (filetype) {
    return mime.getExtension(filetype);
  }

  return 'unsupported';
};

export const isImage = file => {
  const extension = getFileExtension(file);
  const extensions = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'];
  return extensions.includes(extension);
};

export const getFileExtention = file => {
  if (isEmpty(file) || !isString(file)) {
    return undefined;
  }
  // eslint-disable-next-line fp/no-mutating-methods
  return file.split('.').pop();
};

export const fileToBlob = file => {
  if (!file || (file && !file.type)) {
    throw new Error('Invalid or no file provided.');
  }
  return new Blob([file], {type: file.type});
};

const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
};

export const prepareFileBlob = file => {
  if (file.filename && file.filetype && file.url.includes('data:')) {
    const [part1, part2] = file.url.split(';base64,');
    return b64toBlob(part2, part1.replace('data:', ''));
  }
  if (file.name) {
    return fileToBlob(file);
  }
  return file;
};

export const prepareFileProps = (file = {}) => {
  const size = getObjectProp(file, 'size');
  return {
    ext: getObjectProp(file, 'extension'),
    id: getObjectProp(file, 'id'),
    name: getObjectProp(file, 'name'),
    size,
    humanSize: `${size}KB`,
    url: getObjectProp(file, 'url'),
  };
};
